<label
  class="checkbox-wrapper"
  [class.checkbox-wrapper--no-hover]="isHoverAnimation === false"
  [class.checkbox-wrapper--small]="size === 'small'"
  [class.checkbox-wrapper--large]="size === 'large'"
  [class.checkbox-wrapper--disabled]="disabled"
  [class.checkbox-wrapper--error]="error"
>
  <span class="checkbox-container">
    <span class="checkbox-background"></span>
    <span
      class="checkbox-box"
      [class.checkbox-box--checked]="checked"
      [class.checkbox-box--indeterminate]="indeterminate"
    >
      <svg
        *ngIf="checked && !indeterminate"
        class="checkbox-icon"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M3.5 8.5L6.5 11.5L12.5 4.5"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        *ngIf="indeterminate"
        class="checkbox-icon"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M4 8H12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </span>
  </span>

  <input
    type="checkbox"
    class="checkbox-input"
    [checked]="checked"
    [disabled]="disabled"
    [indeterminate]="indeterminate"
    (change)="onChangeInput($event)"
  />

  <span *ngIf="label" class="checkbox-label">{{ label }}</span>
</label>
